(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (window.__cartDrawerInit) return;
    window.__cartDrawerInit = true;

    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var motion = null;

    function isPlainLeftClick(event) {
      return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
    }

    function getCartTrigger() {
      return document.querySelector('[data-cart-drawer-open]');
    }

    function initMotion() {
      if (motion) return motion;
      if (!window.DrawerMotion) return null;

      var panel = drawer.querySelector('.cart-drawer__panel');
      var backdrop = drawer.querySelector('.cart-drawer__backdrop');

      motion = window.DrawerMotion.create({
        root: drawer,
        panel: panel,
        backdrop: backdrop,
        cascadeSelector:
          '.cart-drawer__header, .cart-drawer__scroll .cart-card, .cart-drawer__scroll .cart-contents--empty, .cart-drawer__footer',
        getFocusTarget: function () {
          return drawer.querySelector('.cart-drawer__close');
        },
        getReturnFocus: function () {
          return getCartTrigger();
        },
        onExpandedChange: function () {}
      });

      window.__cartDrawerMotion = motion;

      return motion;
    }

    function whenMotionReady(callback) {
      var instance = initMotion();
      if (instance) {
        callback(instance);
        return;
      }

      var attempts = 0;
      (function poll() {
        instance = initMotion();
        if (instance) {
          callback(instance);
          return;
        }
        if (attempts >= 120) return;
        attempts += 1;
        requestAnimationFrame(poll);
      })();
    }

    function openCartDrawer() {
      whenMotionReady(function (ready) {
        ready.open();
      });
    }

    function toggleCartDrawer() {
      whenMotionReady(function (ready) {
        ready.toggle();
      });
    }

    function closeCartDrawer() {
      whenMotionReady(function (ready) {
        ready.close();
      });
    }

    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-cart-drawer-open]');
      if (openTrigger) {
        if (!isPlainLeftClick(event)) return;
        event.preventDefault();
        toggleCartDrawer();
        return;
      }

      var closeTrigger = event.target.closest('[data-cart-drawer-close]');
      if (closeTrigger) {
        event.preventDefault();
        closeCartDrawer();
        return;
      }

      var changeBtn = event.target.closest('[data-cart-change]');
      if (changeBtn && !changeBtn.disabled) {
        event.preventDefault();
        var line = parseInt(changeBtn.getAttribute('data-cart-line'), 10);
        var quantity = parseInt(changeBtn.getAttribute('data-cart-quantity'), 10);
        if (!isNaN(line) && !isNaN(quantity)) changeLine(line, quantity);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      whenMotionReady(function (ready) {
        if (ready.isVisible()) ready.close();
      });
    });

    function getSectionsToRender() {
      var sections = ['cart-drawer'];
      if (document.getElementById('MainCartContents')) sections.push('main');
      return sections;
    }

    function accordionKey(details) {
      // Stable identifier independent of transient state classes
      // (is-accordion-open / is-accordion-closing).
      var match = details.className.match(/cart-card--[\w-]+/);
      return match ? match[0] : null;
    }

    function replaceContents(targetId, html) {
      var live = document.getElementById(targetId);
      if (!live || !html) return;

      // Preserve the user-toggled open state of motion accordions (price
      // breakdown, cancellation policy) across the re-render. Without this the
      // fresh server markup is always rendered `open`, so changing quantity
      // would reset / flicker the dropdown open every time.
      var prevOpen = {};
      live.querySelectorAll('[data-motion-accordion]').forEach(function (details) {
        var key = accordionKey(details);
        if (key) {
          prevOpen[key] = details.classList.contains('is-accordion-open') || details.hasAttribute('open');
        }
      });

      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.getElementById(targetId);
      if (!fresh) return;

      // Apply the preserved state onto the fresh markup before insertion. We set
      // BOTH the `open` attribute (read by motion-ui's re-init) and the
      // `is-accordion-open` class (drives the chevron rotation + panel CSS) so
      // the element's first paint already matches its final state — no style
      // change means no transition, so the chevron doesn't re-animate on swap.
      fresh.querySelectorAll('[data-motion-accordion]').forEach(function (details) {
        var key = accordionKey(details);
        if (!key || !Object.prototype.hasOwnProperty.call(prevOpen, key)) return;
        if (prevOpen[key]) {
          details.setAttribute('open', '');
          details.classList.add('is-accordion-open');
        } else {
          details.removeAttribute('open');
          details.classList.remove('is-accordion-open');
        }
      });

      live.innerHTML = fresh.innerHTML;
    }

    function applySections(sections) {
      if (!sections) return;
      replaceContents('CartDrawerContents', sections['cart-drawer']);
      replaceContents('MainCartContents', sections['main']);
    }

    // Re-render the cart sections from the server without a cart mutation.
    // Used by the corporate snippet after applying the discount code to the
    // cart, so the breakdown/total reflect it immediately.
    window.refreshCartSections = function () {
      var ids = getSectionsToRender();
      return fetch(window.location.pathname + '?sections=' + ids.join(','), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          applySections(sections);
          notifyCartUpdated();
        })
        .catch(function () {});
    };

    function resolveCartItemCount(data) {
      if (data && typeof data.item_count === 'number') return data.item_count;
      var node = document.querySelector('#CartDrawerContents [data-cart-count]');
      if (!node) return 0;
      var count = parseInt(node.getAttribute('data-cart-count'), 10);
      return isNaN(count) ? 0 : count;
    }

    function notifyCartUpdated(data) {
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { item_count: resolveCartItemCount(data) }
        })
      );
    }

    function closeOpenVariantSheets() {
      document.querySelectorAll('.pvar-overlay--open').forEach(function (overlay) {
        overlay.classList.remove('pvar-overlay--open');
        overlay.setAttribute('aria-hidden', 'true');
      });
    }

    function setBusy(busy) {
      drawer.querySelectorAll('[data-cart-change]').forEach(function (btn) {
        btn.disabled = busy;
      });
    }

    function changeLine(line, quantity) {
      var url = drawer.getAttribute('data-cart-change-url') || '/cart/change.js';
      setBusy(true);
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: getSectionsToRender().join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          applySections(data.sections);
          notifyCartUpdated(data);
        })
        .catch(function () {})
        .finally(function () {
          setBusy(false);
        });
    }

    function addToCart(form) {
      var url = drawer.getAttribute('data-cart-add-url') || '/cart/add.js';
      var addingLabel = drawer.getAttribute('data-atc-adding-label') || 'Adding...';
      var atcUi = resolveAtcUi(form);

      setAtcLoading(atcUi, true, addingLabel);

      var formData = new FormData(form);
      formData.append('sections', getSectionsToRender().join(','));
      formData.append('sections_url', window.location.pathname);

      fetch(url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || result.data.status) return;
          applySections(result.data.sections);
          notifyCartUpdated(result.data);
          closeOpenVariantSheets();
          openCartDrawer();
        })
        .catch(function () {})
        .finally(function () {
          setAtcLoading(atcUi, false);
          clearAtcTrigger(form);
        });
    }

    function resolveAtcUi(form) {
      var root = form.closest('[data-pvar-root]');
      var useCardTrigger = form.dataset.atcTrigger === 'card';
      var overlay =
        root &&
        (root.querySelector('[data-pvar-overlay]') ||
          (root.dataset.productId
            ? document.getElementById('pvar-overlay-' + root.dataset.productId)
            : null));
      var sheetOpen = overlay && overlay.classList.contains('pvar-overlay--open');

      if (root && (useCardTrigger || !sheetOpen)) {
        var card = root.closest('.product-card');
        if (card) {
          var openBtn = card.querySelector('[data-pvar-open]');
          if (openBtn) {
            var openLabel = openBtn.querySelector('[data-pvar-open-label]') || openBtn;
            return { button: openBtn, label: openLabel };
          }
        }
      }

      var submitBtn = form.querySelector('[type="submit"]');
      var submitLabel = submitBtn && submitBtn.querySelector('[data-pvar-submit-label]');

      if (submitLabel) {
        return { button: submitBtn, label: submitLabel };
      }

      if (submitBtn) {
        return { button: submitBtn, label: submitBtn };
      }

      return null;
    }

    function setAtcLoading(ui, loading, addingLabel) {
      if (!ui || !ui.label) return;

      if (loading) {
        if (!ui.label.dataset.atcDefaultLabel) {
          ui.label.dataset.atcDefaultLabel = ui.label.textContent.trim();
        }
        ui.label.textContent = addingLabel;
        if (ui.button) {
          ui.button.disabled = true;
          ui.button.setAttribute('aria-busy', 'true');
        }
        return;
      }

      if (ui.label.dataset.atcDefaultLabel) {
        ui.label.textContent = ui.label.dataset.atcDefaultLabel;
        delete ui.label.dataset.atcDefaultLabel;
      }

      if (ui.button) {
        ui.button.disabled = false;
        ui.button.removeAttribute('aria-busy');
      }
    }

    function clearAtcTrigger(form) {
      if (form && form.dataset.atcTrigger) {
        delete form.dataset.atcTrigger;
      }
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      var isProductForm = form.querySelector('input[name="form_type"][value="product"]');
      if (!isProductForm) return;
      event.preventDefault();
      addToCart(form);
    });

    whenMotionReady(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-footer-back-to-top]');
    if (!btn) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    var drawer = document.querySelector('[data-header-drawer]');
    var megamenu = document.querySelector('[data-header-megamenu]');
    var megaOverlay = document.querySelector('[data-header-mega-overlay]');
    var headerBar = document.querySelector('[data-header-bar]');
    var megaTrigger = header.querySelector('[data-header-megamenu-trigger]');
    var megaTriggerLink = megaTrigger && megaTrigger.querySelector('.site-header__nav-link');
    var megaPanel = megamenu && megamenu.querySelector('[data-header-megamenu-panel]');
    var drawerPanel = drawer && drawer.querySelector('.site-header__drawer-panel');
    var drawerBackdrop = drawer && drawer.querySelector('.site-header__drawer-backdrop');
    var drawerToggle = header.querySelector('[data-header-menu-open]');
    var plainNavLinks = header.querySelectorAll('.site-header__nav-link:not(.site-header__nav-link--has-chevron)');
    var menuOpenBtns = document.querySelectorAll('[data-header-menu-open]');
    var menuCloseBtns = document.querySelectorAll('[data-header-menu-close]');
    var megaCloseBtns = document.querySelectorAll('[data-header-mega-close]');
    var openIntentTimer;
    var closeIntentTimer;
    var contentOutTimer;
    var drawerContentInTimer;
    var drawerContentOutTimer;
    var drawerCloseFallbackTimer;
    var megaIsOpen = false;
    var megaIsClosing = false;
    var drawerPhase = 'closed';
    var drawerContentRevealed = false;
    var drawerFocusOnClose = false;
    var OPEN_INTENT_MS = 100;
    var CLOSE_INTENT_MS = 150;
    var CONTENT_OUT_MS = 200;
    var OPEN_HEIGHT_MS = 560;
    var CLOSE_HEIGHT_MS = 400;
    var DRAWER_CONTENT_OUT_MS = 160;
    var DRAWER_CLOSE_FALLBACK_MS = 450;
    var EASE_OPEN = 'cubic-bezier(0.32, 0.08, 0.24, 1)';
    var EASE_CLOSE = 'cubic-bezier(0.4, 0, 0.6, 1)';
    var MEGA_COLUMNS = 4;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function syncHeaderBarOffset() {
      if (!headerBar) return;
      var bottom = headerBar.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--site-header-bar-bottom', bottom + 'px');
    }

    function setTriggerExpanded(expanded) {
      if (!megaTriggerLink) return;
      megaTriggerLink.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function measureMegaHeight() {
      if (!megamenu || !megaPanel) return 0;
      var prevHidden = megamenu.hidden;
      var prevHeight = megamenu.style.height;
      megamenu.hidden = false;
      megamenu.style.height = 'auto';
      megamenu.style.visibility = 'hidden';
      var height = megaPanel.offsetHeight;
      megamenu.style.height = prevHeight;
      megamenu.style.visibility = '';
      megamenu.hidden = prevHidden;
      return height;
    }

    function applyContentStagger() {
      if (!megamenu) return;
      var rows = megamenu.querySelectorAll('.site-header__mega-row');
      var footer = megamenu.querySelector('.site-header__megamenu-footer');
      var maxDelay = 120;

      rows.forEach(function (row, index) {
        var col = index % MEGA_COLUMNS;
        var rowIndex = Math.floor(index / MEGA_COLUMNS);
        var delay = 120 + col * 40 + rowIndex * 15;
        row.style.setProperty('--mega-item-delay', delay + 'ms');
        if (delay > maxDelay) maxDelay = delay;
      });

      if (footer) {
        footer.style.setProperty('--mega-item-delay', maxDelay + 40 + 'ms');
      }
    }

    function clearContentStagger() {
      if (!megamenu) return;
      megamenu.querySelectorAll('.site-header__mega-row, .site-header__megamenu-footer').forEach(function (node) {
        node.style.removeProperty('--mega-item-delay');
      });
    }

    function showOverlay() {
      if (!megaOverlay) return;
      megaOverlay.hidden = false;
      megaOverlay.classList.remove('is-closing');
      megaOverlay.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        megaOverlay.classList.add('is-visible');
      });
    }

    function hideOverlay() {
      if (!megaOverlay) return;
      megaOverlay.classList.add('is-closing');
      megaOverlay.classList.remove('is-visible');
      megaOverlay.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () {
        if (!megaIsOpen && !megaIsClosing) megaOverlay.hidden = true;
      }, reducedMotion ? 150 : 300);
    }

    function finishMegamenuClose() {
      if (!megamenu || megaIsOpen) return;
      megamenu.hidden = true;
      megamenu.classList.remove('is-open', 'is-animating', 'is-content-out', 'is-content-in');
      megamenu.style.transition = '';
      megamenu.style.height = '0px';
      clearContentStagger();
      if (megaOverlay) megaOverlay.hidden = true;
      header.classList.remove('is-megamenu-open');
      megaIsClosing = false;
    }

    function openMegamenu() {
      if (!megamenu || !megaTrigger || megaIsOpen || megaIsClosing) return;

      clearTimeout(closeIntentTimer);
      clearTimeout(contentOutTimer);
      syncHeaderBarOffset();

      var targetHeight = measureMegaHeight();
      megamenu.hidden = false;
      megamenu.style.transition = 'none';
      megamenu.style.height = '0px';
      megamenu.offsetHeight;

      header.classList.add('is-megamenu-open');
      megaTrigger.classList.add('is-open');
      setTriggerExpanded(true);
      showOverlay();
      applyContentStagger();

      requestAnimationFrame(function () {
        megamenu.classList.add('is-open', 'is-animating');
        megamenu.classList.remove('is-content-out', 'is-content-in');

        if (reducedMotion) {
          megamenu.style.height = targetHeight + 'px';
          megamenu.classList.add('is-content-in');
          megaIsOpen = true;
          window.setTimeout(function () {
            megamenu.classList.remove('is-animating');
          }, 150);
          return;
        }

        megamenu.style.transition = 'height ' + OPEN_HEIGHT_MS + 'ms ' + EASE_OPEN;
        megamenu.style.height = targetHeight + 'px';

        window.setTimeout(function () {
          if (!megamenu.classList.contains('is-open')) return;
          megamenu.classList.add('is-content-in');
        }, 120);

        megaIsOpen = true;
      });
    }

    function beginMegamenuClose() {
      if (!megamenu || !megaTrigger || !megaIsOpen || megaIsClosing) return;

      megaIsClosing = true;
      megaIsOpen = false;
      megaTrigger.classList.remove('is-open');
      setTriggerExpanded(false);
      megamenu.classList.remove('is-content-in');
      megamenu.classList.add('is-content-out');
      hideOverlay();

      if (reducedMotion) {
        header.classList.remove('is-megamenu-open');
        megamenu.classList.remove('is-open');
        finishMegamenuClose();
        return;
      }

      contentOutTimer = window.setTimeout(function () {
        megamenu.classList.remove('is-content-out');
        megamenu.classList.add('is-animating');
        megamenu.classList.remove('is-open');
        header.classList.remove('is-megamenu-open');
        megamenu.style.transition = 'height ' + CLOSE_HEIGHT_MS + 'ms ' + EASE_CLOSE;
        megamenu.style.height = '0px';
      }, CONTENT_OUT_MS);
    }

    function cancelMegamenuClose() {
      clearTimeout(closeIntentTimer);
      clearTimeout(contentOutTimer);
      if (!megaIsClosing) return;

      megaIsClosing = false;
      megaIsOpen = true;
      megaTrigger.classList.add('is-open');
      setTriggerExpanded(true);
      header.classList.add('is-megamenu-open');
      megamenu.classList.add('is-open', 'is-animating');
      megamenu.classList.remove('is-content-out');
      megamenu.classList.add('is-content-in');
      showOverlay();

      var targetHeight = measureMegaHeight();
      megamenu.style.transition = 'height ' + OPEN_HEIGHT_MS + 'ms ' + EASE_OPEN;
      megamenu.style.height = targetHeight + 'px';
    }

    function scheduleOpenMegamenu() {
      clearTimeout(closeIntentTimer);
      if (megaIsClosing) {
        cancelMegamenuClose();
        return;
      }
      clearTimeout(openIntentTimer);
      if (megaIsOpen) return;
      openIntentTimer = window.setTimeout(openMegamenu, OPEN_INTENT_MS);
    }

    function scheduleCloseMegamenu() {
      clearTimeout(openIntentTimer);
      clearTimeout(closeIntentTimer);
      if (!megaIsOpen && !megaIsClosing) return;
      closeIntentTimer = window.setTimeout(beginMegamenuClose, CLOSE_INTENT_MS);
    }

    if (megamenu) {
      megamenu.addEventListener('transitionend', function (event) {
        if (event.target !== megamenu || event.propertyName !== 'height') return;
        megamenu.classList.remove('is-animating');
        if (!megamenu.classList.contains('is-open') && megaIsClosing) {
          finishMegamenuClose();
        }
      });
    }

    if (megaTriggerLink) {
      megaTriggerLink.setAttribute('aria-haspopup', 'true');
      megaTriggerLink.setAttribute('aria-expanded', 'false');
      megaTriggerLink.setAttribute('aria-controls', 'SiteHeaderMegamenu');
    }

    function clearDrawerTimers() {
      clearTimeout(drawerContentInTimer);
      clearTimeout(drawerContentOutTimer);
      clearTimeout(drawerCloseFallbackTimer);
    }

    function setDrawerToggleExpanded(expanded) {
      if (drawerToggle) drawerToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function applyDrawerStagger() {
      if (!drawer) return;
      var steps = drawer.querySelectorAll('.site-header__drawer-section, .site-header__drawer-promos');
      steps.forEach(function (step, index) {
        step.style.setProperty('--drawer-item-delay', 100 + index * 30 + 'ms');
      });
    }

    function clearDrawerStagger() {
      if (!drawer) return;
      drawer.querySelectorAll('.site-header__drawer-section, .site-header__drawer-promos').forEach(function (node) {
        node.style.removeProperty('--drawer-item-delay');
      });
    }

    function resetDrawerContentAnimation() {
      if (!drawer) return;
      drawer.classList.remove('is-content-in', 'is-content-out');
      drawerContentRevealed = false;
    }

    function finishDrawerClose() {
      if (!drawer || drawerPhase !== 'closing') return;

      clearTimeout(drawerCloseFallbackTimer);
      drawerPhase = 'closed';
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-open', 'is-panel-in', 'is-panel-out', 'is-content-in', 'is-content-out');
      if (drawerBackdrop) drawerBackdrop.classList.remove('is-closing');
      clearDrawerStagger();
      resetDrawerContentAnimation();
      document.body.style.overflow = '';
      setDrawerToggleExpanded(false);

      if (drawerFocusOnClose && drawerToggle) {
        drawerToggle.focus();
      }
      drawerFocusOnClose = false;
    }

    function scheduleDrawerContentIn() {
      clearTimeout(drawerContentInTimer);
      drawerContentInTimer = window.setTimeout(function () {
        if (drawerPhase !== 'opening' && drawerPhase !== 'open') return;
        drawer.classList.add('is-content-in');
        drawerContentRevealed = true;
        if (drawerPhase === 'opening') drawerPhase = 'open';
      }, 100);
    }

    function slideDrawerPanelOpen() {
      if (!drawer) return;

      drawer.classList.remove('is-panel-out', 'is-content-out');
      if (drawerBackdrop) drawerBackdrop.classList.remove('is-closing');

      requestAnimationFrame(function () {
        if (drawerPhase !== 'opening') return;
        drawer.classList.add('is-open', 'is-panel-in');
        if (drawerPanel) drawerPanel.offsetHeight;
        scheduleDrawerContentIn();
      });
    }

    function requestDrawerOpen() {
      if (!drawer) return;
      if (drawerPhase === 'opening' || drawerPhase === 'open') return;

      clearDrawerTimers();
      drawerFocusOnClose = false;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setDrawerToggleExpanded(true);
      applyDrawerStagger();

      var focusTarget = drawer.querySelector('[data-header-menu-close]');

      if (reducedMotion) {
        drawerPhase = 'open';
        drawer.classList.remove('is-panel-out', 'is-content-out');
        drawer.classList.add('is-open', 'is-panel-in', 'is-content-in');
        drawerContentRevealed = true;
        if (focusTarget) focusTarget.focus();
        return;
      }

      if (drawerPhase === 'closing') {
        drawerPhase = 'opening';
        resetDrawerContentAnimation();
        slideDrawerPanelOpen();
        if (focusTarget) focusTarget.focus();
        return;
      }

      drawerPhase = 'opening';
      resetDrawerContentAnimation();
      drawer.classList.remove('is-panel-in', 'is-panel-out', 'is-open', 'is-content-in', 'is-content-out');
      if (drawerPanel) drawerPanel.offsetHeight;

      requestAnimationFrame(function () {
        slideDrawerPanelOpen();
        if (focusTarget) focusTarget.focus();
      });
    }

    function slideDrawerPanelClosed() {
      if (!drawer || drawerPhase !== 'closing') return;

      requestAnimationFrame(function () {
        if (drawerPhase !== 'closing') return;

        var hadPanelIn = drawer.classList.contains('is-panel-in');
        drawer.classList.remove('is-content-out', 'is-panel-in', 'is-open');
        drawer.classList.add('is-panel-out');
        if (drawerBackdrop) drawerBackdrop.classList.add('is-closing');

        if (!hadPanelIn) {
          finishDrawerClose();
          return;
        }

        if (drawerPanel) drawerPanel.offsetHeight;

        clearTimeout(drawerCloseFallbackTimer);
        drawerCloseFallbackTimer = window.setTimeout(function () {
          if (drawerPhase === 'closing') finishDrawerClose();
        }, DRAWER_CLOSE_FALLBACK_MS);
      });
    }

    function requestDrawerClose() {
      if (!drawer) return;
      if (drawerPhase === 'closed' || drawerPhase === 'closing') return;

      clearDrawerTimers();
      drawerPhase = 'closing';
      drawerFocusOnClose = true;
      setDrawerToggleExpanded(false);

      if (reducedMotion) {
        drawer.classList.remove('is-open', 'is-panel-in', 'is-content-in');
        finishDrawerClose();
        return;
      }

      var contentOutDelay = drawerContentRevealed ? DRAWER_CONTENT_OUT_MS : 0;

      drawer.classList.remove('is-content-in');
      drawer.classList.add('is-content-out');

      drawerContentOutTimer = window.setTimeout(slideDrawerPanelClosed, contentOutDelay);
    }

    function toggleDrawer() {
      if (drawerPhase === 'opening' || drawerPhase === 'open') {
        requestDrawerClose();
      } else {
        requestDrawerOpen();
      }
    }

    if (drawerPanel) {
      drawerPanel.addEventListener('transitionend', function (event) {
        if (event.target !== drawerPanel || event.propertyName !== 'transform') return;

        if (drawer.classList.contains('is-panel-in') && !drawer.classList.contains('is-panel-out')) {
          if (drawerPhase === 'opening') drawerPhase = 'open';
          return;
        }

        if (drawer.classList.contains('is-panel-out') && !drawer.classList.contains('is-panel-in')) {
          clearTimeout(drawerCloseFallbackTimer);
          finishDrawerClose();
        }
      });
    }

    function closeMegamenuImmediate() {
      clearTimeout(openIntentTimer);
      clearTimeout(closeIntentTimer);
      clearTimeout(contentOutTimer);
      if (!megaIsOpen && !megaIsClosing) return;
      beginMegamenuClose();
    }

    menuOpenBtns.forEach(function (btn) {
      btn.addEventListener('click', toggleDrawer);
    });

    menuCloseBtns.forEach(function (btn) {
      btn.addEventListener('click', requestDrawerClose);
    });

    megaCloseBtns.forEach(function (btn) {
      btn.addEventListener('click', closeMegamenuImmediate);
    });

    syncHeaderBarOffset();
    window.addEventListener('resize', syncHeaderBarOffset);
    window.addEventListener('scroll', function () {
      syncHeaderBarOffset();
      clearTimeout(openIntentTimer);
      if (megaIsOpen) closeMegamenuImmediate();
    }, { passive: true });

    if (megaTrigger && megamenu) {
      megaTrigger.addEventListener('mouseenter', scheduleOpenMegamenu);
      megaTrigger.addEventListener('mouseleave', scheduleCloseMegamenu);
      megaTrigger.addEventListener('focusin', scheduleOpenMegamenu);

      megamenu.addEventListener('mouseenter', function () {
        clearTimeout(closeIntentTimer);
        clearTimeout(openIntentTimer);
        if (megaIsClosing) cancelMegamenuClose();
      });
      megamenu.addEventListener('mouseleave', scheduleCloseMegamenu);

      plainNavLinks.forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          clearTimeout(openIntentTimer);
          if (megaIsOpen || megaIsClosing) scheduleCloseMegamenu();
        });
        link.addEventListener('focusin', function () {
          clearTimeout(openIntentTimer);
          if (megaIsOpen) scheduleCloseMegamenu();
        });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (drawerPhase !== 'closed') requestDrawerClose();
        closeMegamenuImmediate();
      }
    });

    function getCorpCookie(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[2]) : '';
    }

    function initCorpAccount() {
      var account = header.querySelector('[data-corp-account]');
      if (!account) return;

      var welcomeEl = account.querySelector('[data-corp-welcome]');
      var logoutBtn = account.querySelector('[data-corp-logout]');
      var loginUrl = header.getAttribute('data-corp-login-url') || '/pages/login';
      var hasSession = !!getCorpCookie('corp_session');

      if (!hasSession && !(window.corpSession && window.corpSession.email)) {
        account.hidden = true;
        return;
      }

      var email = (window.corpSession && window.corpSession.email) || localStorage.getItem('corp_email') || getCorpCookie('corp_email') || '';
      var name = email.split('@')[0] || email;
      var company = localStorage.getItem('corp_company_name') || '';

      if (welcomeEl) {
        welcomeEl.textContent = company ? 'Welcome, ' + name + ' · ' + company : 'Welcome, ' + name;
      }

      account.hidden = false;

      if (logoutBtn) {
        logoutBtn.addEventListener('click', function () {
          document.cookie = 'corp_session=; path=/; max-age=0';
          document.cookie = 'corp_email=; path=/; max-age=0';
          localStorage.removeItem('corp_discount_code');
          localStorage.removeItem('corp_company_name');
          localStorage.removeItem('corp_discount_label');
          localStorage.removeItem('corp_email');
          delete window.corpSession;
          if (window.corpClearCartAttribute) {
            window.corpClearCartAttribute();
          }
          window.location.replace(loginUrl);
        });
      }
    }

    initCorpAccount();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-why-frido"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MARQUEE_SPEED = 50;
    var RESIZE_DEBOUNCE = 150;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function debounce(fn, wait) {
      var timer;
      return function () {
        clearTimeout(timer);
        var args = arguments;
        var context = this;
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, wait);
      };
    }

    function initMarquee(root) {
      if (root.dataset.homeMarqueeInit === 'true') return;
      root.dataset.homeMarqueeInit = 'true';

      var viewport = root.querySelector('.home-why__marquee-viewport');
      var track = root.querySelector('[data-home-marquee-track]');
      var template = root.querySelector('[data-home-marquee-sequence]');
      if (!viewport || !track || !template) return;

      var sequenceHtml = template.innerHTML;
      var resizeObserver;

      function buildMarquee() {
        track.classList.remove('is-animate');
        track.style.removeProperty('--marquee-duration');
        track.style.removeProperty('--marquee-shift');
        track.replaceChildren();

        if (reducedMotion) {
          var staticSequence = document.createElement('div');
          staticSequence.className = 'home-why__marquee-sequence';
          staticSequence.innerHTML = sequenceHtml;
          track.appendChild(staticSequence);
          return;
        }

        var measureWrap = document.createElement('div');
        measureWrap.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;white-space:nowrap;';
        var measureSequence = document.createElement('div');
        measureSequence.className = 'home-why__marquee-sequence';
        measureSequence.innerHTML = sequenceHtml;
        measureWrap.appendChild(measureSequence);
        viewport.appendChild(measureWrap);

        var sequenceWidth = measureSequence.offsetWidth;
        var containerWidth = viewport.offsetWidth;
        viewport.removeChild(measureWrap);

        if (!sequenceWidth || !containerWidth) {
          var fallback = document.createElement('div');
          fallback.className = 'home-why__marquee-sequence';
          fallback.innerHTML = sequenceHtml;
          track.appendChild(fallback);
          return;
        }

        var sequencesPerHalf = Math.max(1, Math.ceil(containerWidth / sequenceWidth));
        var totalSequences = sequencesPerHalf * 2;
        var fragment = document.createDocumentFragment();

        for (var i = 0; i < totalSequences; i++) {
          var sequence = document.createElement('div');
          sequence.className = 'home-why__marquee-sequence';
          sequence.innerHTML = sequenceHtml;
          if (i > 0) sequence.setAttribute('aria-hidden', 'true');
          fragment.appendChild(sequence);
        }

        track.replaceChildren(fragment);

        var halfWidth = track.scrollWidth / 2;
        if (halfWidth <= 0) return;

        var duration = halfWidth / MARQUEE_SPEED;
        track.style.setProperty('--marquee-shift', halfWidth + 'px');
        track.style.setProperty('--marquee-duration', duration + 's');
        track.classList.add('is-animate');
      }

      var rebuild = debounce(buildMarquee, RESIZE_DEBOUNCE);

      buildMarquee();

      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(rebuild);
        resizeObserver.observe(viewport);
      } else {
        window.addEventListener('resize', rebuild);
      }
    }

    function boot() {
      document.querySelectorAll('[data-home-marquee]').forEach(initMarquee);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('[corp-login] JS bundle loaded');

    var root = document.querySelector('[data-corp-login]');
    if (!root) {
      console.warn('[corp-login] section not found in DOM');
      return;
    }

    console.log('[corp-login] section found, version:', root.getAttribute('data-corp-login-version'));

    var AUTH_BASE = root.getAttribute('data-auth-base') || 'https://evolv-auth-backend.onrender.com';
    var RESEND_COOLDOWN_MS = 30000;
    var OTP_TIMER_SECONDS = 30;

    var labels = {
      continue: root.dataset.labelContinue || 'Continue',
      proceeding: root.dataset.labelProceeding || 'Proceeding..',
      sending: root.dataset.labelSending || 'Sending..',
      resend: root.dataset.labelResend || 'Resend code',
      codeSent: root.dataset.labelCodeSent || 'Code sent',
      genericError: root.dataset.labelGenericError || 'Something went wrong. Please try again.',
      invalidEmail: root.dataset.labelInvalidEmail || 'Please enter a valid email address.',
      invalidCode: root.dataset.labelInvalidCode || 'Please enter the 6-digit code.'
    };

    var state = {
      email: '',
      requestId: '',
      resendAvailableAt: 0,
      timerInterval: null,
      timerEndsAt: 0
    };

    var step1 = root.querySelector('[data-login-step="1"]');
    var step2 = root.querySelector('[data-login-step="2"]');
    var emailForm = root.querySelector('[data-login-email-form]');
    var otpForm = root.querySelector('[data-login-otp-form]');
    var emailInput = root.querySelector('[data-login-email]');
    var emailError = root.querySelector('[data-login-email-error]');
    var otpError = root.querySelector('[data-login-otp-error]');
    var emailSubmit = root.querySelector('[data-login-email-submit]');
    var emailSubmitLabel = root.querySelector('[data-login-email-submit-label]');
    var otpSubmit = root.querySelector('[data-login-otp-submit]');
    var otpSubmitLabel = root.querySelector('[data-login-otp-submit-label]');
    var otpSpinner = root.querySelector('[data-login-otp-spinner]');
    var displayEmail = root.querySelector('[data-login-display-email]');
    var editBtn = root.querySelector('[data-login-edit]');
    var resendBtn = root.querySelector('[data-login-resend]');
    var resendLabel = root.querySelector('[data-login-resend-label]');
    var timerEl = root.querySelector('[data-login-timer]');
    var otpBoxes = root.querySelectorAll('[data-login-otp-box]');
    var domainPanel = root.querySelector('[data-login-domain-panel]');
    var requestAccessLink = root.querySelector('[data-login-request-access]');
    var domainNameEl = root.querySelector('[data-login-domain-name]');
    var emailCopyBtn = root.querySelector('.corp-email-pill__copy');

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function showError(el, message) {
      if (!el) return;
      el.textContent = message;
      el.hidden = false;
    }

    function hideError(el) {
      if (!el) return;
      el.hidden = true;
      el.textContent = '';
    }

    function setEmailInputError(active) {
      if (emailInput) emailInput.classList.toggle('login-field__input--error', active);
    }

    function buildAccessMailto() {
      return 'mailto:corporate@myfrido.com?subject=' + encodeURIComponent('Corporate tie-up request');
    }

    function showDomainErrorPanel(email) {
      hideError(emailError);
      setEmailInputError(false);
      var domain = (email.split('@')[1] || email || '').trim();
      if (domainNameEl) domainNameEl.textContent = domain;
      if (domainPanel) domainPanel.hidden = false;
      if (emailSubmit) {
        emailSubmit.hidden = true;
        emailSubmit.setAttribute('aria-hidden', 'true');
      }
      if (requestAccessLink) requestAccessLink.href = buildAccessMailto();
    }

    function hideDomainErrorPanel() {
      if (domainPanel) domainPanel.hidden = true;
      if (emailSubmit) {
        emailSubmit.hidden = false;
        emailSubmit.removeAttribute('aria-hidden');
      }
    }

    function initEmailPillCopy() {
      if (!emailCopyBtn) return;

      emailCopyBtn.addEventListener('click', function () {
        var email = emailCopyBtn.getAttribute('data-clipboard') || 'corporate@myfrido.com';

        function showCopiedState() {
          emailCopyBtn.classList.add('is-copied');
          window.setTimeout(function () {
            emailCopyBtn.classList.remove('is-copied');
          }, 1500);
        }

        function onSuccess() {
          showCopiedState();
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(email).then(onSuccess).catch(function () {
            fallbackCopy(email, onSuccess);
          });
          return;
        }

        fallbackCopy(email, onSuccess);
      });

      function fallbackCopy(text, callback) {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          if (document.execCommand('copy')) callback();
        } catch (e) {}
        document.body.removeChild(textarea);
      }
    }

    initEmailPillCopy();

    function setCorpCookie(name, value, expires) {
      var secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; expires=' + expires + '; SameSite=Lax' + secure;
    }

    function hasCorpSessionCookie() {
      return document.cookie.split(';').some(function (c) {
        return c.trim().indexOf('corp_session=') === 0;
      });
    }

    function goToStep(step) {
      if (step === 1) {
        step1.hidden = false;
        step2.hidden = true;
        stopTimer();
      } else {
        step1.hidden = true;
        step2.hidden = false;
        if (displayEmail) displayEmail.textContent = state.email;
        clearOtp();
        startTimer();
        updateResendState();
        var first = root.querySelector('[data-login-otp-first]');
        if (first) first.focus();
      }
    }

    function clearOtp() {
      otpBoxes.forEach(function (box) {
        box.value = '';
      });
      hideError(otpError);
    }

    function getOtpValue() {
      return Array.prototype.map.call(otpBoxes, function (box) {
        return box.value;
      }).join('');
    }

    function formatTimer(seconds) {
      var mins = Math.floor(seconds / 60);
      var secs = seconds % 60;
      return String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
    }

    function stopTimer() {
      if (state.timerInterval) {
        clearInterval(state.timerInterval);
        state.timerInterval = null;
      }
    }

    function startTimer() {
      stopTimer();
      state.timerEndsAt = Date.now() + OTP_TIMER_SECONDS * 1000;
      function tick() {
        var remaining = Math.max(0, Math.ceil((state.timerEndsAt - Date.now()) / 1000));
        if (timerEl) timerEl.textContent = formatTimer(remaining);
        if (remaining === 0) stopTimer();
      }
      tick();
      state.timerInterval = setInterval(tick, 250);
    }

    function updateResendState() {
      if (!resendBtn) return;
      var remaining = state.resendAvailableAt - Date.now();
      resendBtn.disabled = remaining > 0;
    }

    function startResendCooldown() {
      state.resendAvailableAt = Date.now() + RESEND_COOLDOWN_MS;
      updateResendState();
      var cooldownTimer = setInterval(function () {
        updateResendState();
        if (Date.now() >= state.resendAvailableAt) clearInterval(cooldownTimer);
      }, 500);
    }

    function sendCode() {
      console.log('[corp-login] send-code request', { email: state.email });
      return fetch(AUTH_BASE + '/send-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ email: state.email })
      }).then(function (res) {
        return res.json().catch(function () {
          return {};
        }).then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      });
    }

    function handleSendCodeResult(result, advanceOnSuccess) {
      console.log('[corp-login] send-code response', result);
      if (result.ok) {
        state.requestId = result.data.requestId || result.data.request_id || '';
        hideError(emailError);
        hideDomainErrorPanel();
        setEmailInputError(false);
        if (advanceOnSuccess) goToStep(2);
        startResendCooldown();
        return true;
      }

      if (result.status === 403) {
        showDomainErrorPanel(state.email);
      } else {
        showError(emailError, labels.genericError);
        setEmailInputError(true);
      }
      return false;
    }

    function handleEmailSubmit(event) {
      if (event) event.preventDefault();

      state.email = (emailInput.value || '').trim();
      console.log('[corp-login] email submit', { email: state.email });

      hideError(emailError);
      hideDomainErrorPanel();
      setEmailInputError(false);

      if (!isValidEmail(state.email)) {
        showError(emailError, labels.invalidEmail);
        setEmailInputError(true);
        return;
      }

      emailSubmit.disabled = true;
      emailSubmitLabel.textContent = labels.sending;

      sendCode()
        .then(function (result) {
          handleSendCodeResult(result, true);
        })
        .catch(function (err) {
          console.error('[corp-login] send-code failed', err);
          showError(emailError, labels.genericError);
          setEmailInputError(true);
        })
        .finally(function () {
          emailSubmit.disabled = false;
          emailSubmitLabel.textContent = labels.continue;
        });
    }

    function handleOtpSubmit(event) {
      if (event) event.preventDefault();
      hideError(otpError);

      var otp = getOtpValue();
      if (otp.length !== 6) {
        showError(otpError, labels.invalidCode);
        return;
      }

      otpSubmit.disabled = true;
      otpSpinner.hidden = false;
      otpSubmitLabel.textContent = labels.proceeding;

      console.log('[corp-login] verify-code request', {
        email: state.email,
        requestId: state.requestId
      });

      var redirecting = false;

      fetch(AUTH_BASE + '/verify-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          email: state.email,
          otp: otp,
          requestId: state.requestId
        })
      })
        .then(function (res) {
          return res.json().catch(function () {
            return {};
          }).then(function (data) {
            return { ok: res.ok, status: res.status, data: data };
          });
        })
        .then(function (result) {
          console.log('[corp-login] verify-code response', result);

          var data = result.data || {};
          var sessionToken = data.sessionToken || data.session_token || data.token;
          var verified = result.ok && data.success !== false && sessionToken;

          if (!verified) {
            console.error('[corp-login] verify failed or missing sessionToken', result);
            showError(otpError, labels.genericError);
            return;
          }

          try {
            var email = data.email || state.email;
            var expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();

            setCorpCookie('corp_session', sessionToken, expires);
            setCorpCookie('corp_email', email, expires);

            console.log('[corp-login] Cookie set:', document.cookie);

            if (data.discountCode) localStorage.setItem('corp_discount_code', data.discountCode);
            if (data.companyName) localStorage.setItem('corp_company_name', data.companyName);
            localStorage.setItem('corp_email', email);

            var discountLabel = '';
            if (data.discountLabel) {
              discountLabel = String(data.discountLabel);
            } else if (data.discount_label) {
              discountLabel = String(data.discount_label);
            } else if (data.discountDisplay) {
              discountLabel = String(data.discountDisplay);
            } else if (data.discount_display) {
              discountLabel = String(data.discount_display);
            } else {
              var discountPercent =
                data.discountPercent ?? data.discount_percent ?? data.discountPercentage ?? data.discount_percentage;
              var discountAmount =
                data.discountAmount ?? data.discount_amount ?? data.discountValue ?? data.discount_value;
              var discountType = String(data.discountType || data.discount_type || '').toLowerCase();

              if (discountType === 'percent' && discountPercent != null && discountPercent !== '') {
                discountLabel = String(discountPercent).replace(/%/g, '') + '%';
              } else if (
                (discountType === 'fixed' || discountType === 'amount' || discountType === 'rupees') &&
                discountAmount != null &&
                discountAmount !== ''
              ) {
                discountLabel = '₹' + Number(discountAmount).toLocaleString('en-IN');
              } else if (discountPercent != null && discountPercent !== '') {
                discountLabel = String(discountPercent).replace(/%/g, '') + '%';
              } else if (discountAmount != null && discountAmount !== '') {
                discountLabel = '₹' + Number(discountAmount).toLocaleString('en-IN');
              }
            }

            if (discountLabel) localStorage.setItem('corp_discount_label', discountLabel);

            if (!hasCorpSessionCookie()) {
              console.error('[corp-login] Cookie not set, cannot redirect');
              alert('Login succeeded but session could not be saved. Please ensure cookies are enabled.');
              return;
            }

            // Auto-open the discount sheet once on the page we land on after login.
            localStorage.setItem('corp_disc_autoopen', '1');

            var params = new URLSearchParams(window.location.search);
            var returnTo = params.get('return_to') || '/';
            console.log('[corp-login] Redirecting to:', returnTo);
            redirecting = true;
            window.location.replace(returnTo);
          } catch (e) {
            console.error('[corp-login] Failed to save session after verify', e);
            showError(otpError, labels.genericError);
          }
        })
        .catch(function (err) {
          console.error('[corp-login] verify-code failed', err);
          showError(otpError, labels.genericError);
        })
        .finally(function () {
          if (redirecting) return;
          otpSubmit.disabled = false;
          otpSpinner.hidden = true;
          otpSubmitLabel.textContent = labels.continue;
        });
    }

    if (emailForm) {
      emailForm.addEventListener('submit', handleEmailSubmit);
    }

    if (emailSubmit) {
      emailSubmit.addEventListener('click', function (event) {
        event.preventDefault();
        handleEmailSubmit(event);
      });
    }

    if (emailInput) {
      emailInput.addEventListener('input', function () {
        if (domainPanel && !domainPanel.hidden) {
          hideDomainErrorPanel();
          hideError(emailError);
          setEmailInputError(false);
        }
      });
    }

    if (otpForm) {
      otpForm.addEventListener('submit', handleOtpSubmit);
    }

    if (otpSubmit) {
      otpSubmit.addEventListener('click', function (event) {
        event.preventDefault();
        handleOtpSubmit(event);
      });
    }

    if (editBtn) {
      editBtn.addEventListener('click', function () {
        goToStep(1);
      });
    }

    if (resendBtn) {
      resendBtn.addEventListener('click', function () {
        if (resendBtn.disabled) return;
        resendBtn.disabled = true;

        sendCode()
          .then(function (result) {
            if (result.ok) {
              state.requestId = result.data.requestId || result.data.request_id || '';
              resendLabel.textContent = labels.codeSent;
              startTimer();
              startResendCooldown();
              setTimeout(function () {
                resendLabel.textContent = labels.resend;
              }, 2000);
            } else if (result.status === 403) {
              goToStep(1);
              showDomainErrorPanel(state.email);
            } else {
              showError(otpError, labels.genericError);
            }
          })
          .catch(function (err) {
            console.error('[corp-login] resend failed', err);
            showError(otpError, labels.genericError);
          })
          .finally(function () {
            updateResendState();
          });
      });
    }

    otpBoxes.forEach(function (box, index) {
      box.addEventListener('input', function () {
        box.value = box.value.replace(/\D/g, '').slice(0, 1);
        if (box.value && index < otpBoxes.length - 1) {
          otpBoxes[index + 1].focus();
        }
      });

      box.addEventListener('keydown', function (event) {
        if (event.key === 'Backspace' && !box.value && index > 0) {
          otpBoxes[index - 1].focus();
        }
      });

      box.addEventListener('paste', function (event) {
        event.preventDefault();
        var pasted = (event.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '').slice(0, 6);
        pasted.split('').forEach(function (digit, i) {
          if (otpBoxes[i]) otpBoxes[i].value = digit;
        });
        if (pasted.length > 0) {
          otpBoxes[Math.min(pasted.length, otpBoxes.length) - 1].focus();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mckinsey-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-mckinsey-catalog]');
    if (!root) return;

    var tabsWrap = root.querySelector('[data-mckinsey-tabs-wrap]');
    var tabsEl = root.querySelector('[data-mckinsey-tabs]');
    var indicator = root.querySelector('[data-mckinsey-tabs-indicator]');
    var tabs = root.querySelectorAll('[data-mckinsey-tab]');
    var panels = root.querySelectorAll('[data-mckinsey-panel]');
    if (!tabs.length || !panels.length || !tabsEl || !indicator) return;

    var activeIndex = 0;
    var isAnimating = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var panelFadeMs = reduceMotion ? 0 : 200;
    var scrollEndThreshold = 10;

    tabs.forEach(function (tab, i) {
      if (tab.classList.contains('mckinsey-tab--active')) {
        activeIndex = i;
      }
    });

    function updateIndicator(tab, instant) {
      var targetTab = tab || tabs[activeIndex] || tabs[0];
      if (!targetTab) return;

      if (instant) {
        indicator.classList.add('is-instant');
      }

      indicator.style.width = targetTab.offsetWidth + 'px';
      indicator.style.transform = 'translateX(' + targetTab.offsetLeft + 'px)';

      if (instant) {
        indicator.offsetHeight;
        indicator.classList.remove('is-instant');
      }
    }

    function updateTabsWrapScrollEnd() {
      if (!tabsWrap) return;
      var atEnd = tabsWrap.scrollLeft + tabsWrap.clientWidth >= tabsWrap.scrollWidth - scrollEndThreshold;
      tabsWrap.classList.toggle('is-end', atEnd);
    }

    function scrollTabIntoView(tab) {
      if (!tab || reduceMotion) {
        tab.scrollIntoView({ inline: 'center', block: 'nearest' });
        return;
      }
      tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    function setTabStates(index) {
      tabs.forEach(function (tab, i) {
        var isActive = i === index;
        tab.classList.toggle('mckinsey-tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function switchPanel(fromIndex, toIndex) {
      if (fromIndex === toIndex) return Promise.resolve();

      var outgoing = panels[fromIndex];
      var incoming = panels[toIndex];
      if (!incoming) return Promise.resolve();

      if (reduceMotion || panelFadeMs === 0) {
        if (outgoing) {
          outgoing.classList.remove('mckinsey-catalog__panel--active', 'is-leaving', 'is-entering');
          outgoing.setAttribute('aria-hidden', 'true');
        }
        incoming.classList.remove('is-leaving', 'is-entering');
        incoming.classList.add('mckinsey-catalog__panel--active');
        incoming.setAttribute('aria-hidden', 'false');
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        if (outgoing) {
          outgoing.classList.remove('mckinsey-catalog__panel--active');
          outgoing.classList.add('is-leaving');
          outgoing.setAttribute('aria-hidden', 'true');
        }

        window.setTimeout(function () {
          if (outgoing) {
            outgoing.classList.remove('is-leaving');
          }

          incoming.classList.add('is-entering');
          incoming.setAttribute('aria-hidden', 'false');

          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              incoming.classList.add('mckinsey-catalog__panel--active');
              window.setTimeout(function () {
                incoming.classList.remove('is-entering');
                resolve();
              }, panelFadeMs);
            });
          });
        }, panelFadeMs);
      });
    }

    function activateTab(index, options) {
      var opts = options || {};
      if (index < 0 || index >= tabs.length) return;
      if (tabs[index].disabled) return;
      if (isAnimating && index === activeIndex) return;

      var previousIndex = activeIndex;
      if (index === previousIndex && !opts.force) return;

      var clickedTab = tabs[index];
      isAnimating = true;
      activeIndex = index;

      updateIndicator(clickedTab);
      setTabStates(index);

      if (opts.scrollTab !== false) {
        scrollTabIntoView(clickedTab);
      }

      switchPanel(previousIndex, index).then(function () {
        isAnimating = false;
        updateIndicator(clickedTab, true);
      });
    }

    function bindPressFeedback(tab) {
      var iconWrap = tab.querySelector('.mckinsey-tab__icon-wrap');
      if (!iconWrap) return;

      function clearPressed() {
        iconWrap.classList.remove('is-pressed');
      }

      tab.addEventListener('pointerdown', function () {
        if (tab.disabled || tab.classList.contains('mckinsey-tab--active')) return;
        iconWrap.classList.add('is-pressed');
      });

      tab.addEventListener('pointerup', clearPressed);
      tab.addEventListener('pointercancel', clearPressed);
      tab.addEventListener('pointerleave', clearPressed);
    }

    tabs.forEach(function (tab) {
      bindPressFeedback(tab);

      tab.addEventListener('click', function () {
        if (tab.disabled) return;
        activateTab(Number(tab.getAttribute('data-tab-index')));
      });
    });

    if (tabsWrap) {
      tabsWrap.addEventListener('scroll', function () {
        updateTabsWrapScrollEnd();
        updateIndicator(tabs[activeIndex], true);
      }, { passive: true });
      updateTabsWrapScrollEnd();
    }

    window.addEventListener('resize', function () {
      updateIndicator(tabs[activeIndex], true);
    });

    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(function () {
        updateIndicator(tabs[activeIndex], true);
      });
      resizeObserver.observe(tabsEl);
      tabs.forEach(function (tab) {
        resizeObserver.observe(tab);
      });
    }

    updateIndicator(tabs[activeIndex], true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-product-highlights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHighlights(root) {
      if (root.dataset.hlBound) return;
      root.dataset.hlBound = 'true';

      var carousel = root.querySelector('[data-hl-carousel]');
      var prev = root.querySelector('[data-hl-prev]');
      var next = root.querySelector('[data-hl-next]');
      if (!carousel || !prev || !next) return;

      function step(delta) {
        if (typeof carousel.getActiveIndex !== 'function' || typeof carousel.goTo !== 'function') return;
        carousel.goTo(carousel.getActiveIndex() + delta);
      }

      prev.addEventListener('click', function () {
        step(-1);
      });
      next.addEventListener('click', function () {
        step(1);
      });
    }

    function init() {
      document.querySelectorAll('[data-hl-root]').forEach(initHighlights);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-search-page]');
    if (!root) return;

    var form = root.querySelector('[data-search-form]');
    var input = root.querySelector('[data-search-input]');
    var clearBtn = root.querySelector('[data-search-clear]');
    var backBtn = root.querySelector('[data-search-back]');
    var predictive = root.querySelector('[data-search-predictive]');
    var recentSection = root.querySelector('[data-search-recent-section]');
    var recentList = root.querySelector('[data-search-recent-list]');
    var suggestBase = root.getAttribute('data-search-suggest-url') || '/search/suggest';
    var removeLabelTemplate = root.getAttribute('data-recent-label') || 'Remove @@';
    var showAllPrefix = root.getAttribute('data-show-all-prefix') || 'Show all results for';
    var categoryLabel = root.getAttribute('data-category-label') || 'Category';

    var STORAGE_KEY = 'frido_recent_searches';
    var MAX_RECENT = 8;
    var debounceTimer = null;
    var activeController = null;

    function getRecentSearches() {
      try {
        var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(stored) ? stored.filter(Boolean) : [];
      } catch (error) {
        return [];
      }
    }

    function saveRecentSearches(items) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_RECENT)));
    }

    function addRecentSearch(term) {
      var value = String(term || '').trim();
      if (!value) return;
      var items = getRecentSearches().filter(function (item) {
        return item.toLowerCase() !== value.toLowerCase();
      });
      items.unshift(value);
      saveRecentSearches(items);
    }

    function removeRecentSearch(term) {
      var value = String(term || '').trim();
      saveRecentSearches(
        getRecentSearches().filter(function (item) {
          return item !== value;
        })
      );
      renderRecentSearches();
    }

    function formatMoney(amount) {
      var cents = Number(amount);
      if (!Number.isFinite(cents)) return '';
      var rupees = Math.round(cents / 100);
      return '₹' + rupees.toLocaleString('en-IN');
    }

    function searchUrl(query) {
      return '/search?type=product&q=' + encodeURIComponent(query);
    }

    function renderRecentSearches() {
      if (!recentSection || !recentList) return;

      var items = getRecentSearches();
      recentList.innerHTML = '';

      if (!items.length) {
        recentSection.hidden = true;
        return;
      }

      recentSection.hidden = false;

      items.forEach(function (term) {
        var pill = document.createElement('div');
        pill.className = 'search-page__recent-pill';
        pill.setAttribute('role', 'listitem');

        var link = document.createElement('a');
        link.className = 'search-page__recent-pill-text';
        link.href = searchUrl(term);
        link.textContent = term;

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'search-page__recent-remove';
        remove.setAttribute('aria-label', removeLabelTemplate.replace('@@', term));
        remove.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M4.5 4.5l9 9M13.5 4.5l-9 9" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/></svg>';
        remove.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          removeRecentSearch(term);
        });

        pill.appendChild(link);
        pill.appendChild(remove);
        recentList.appendChild(pill);
      });
    }

    function hidePredictive() {
      if (!predictive) return;
      predictive.hidden = true;
      predictive.innerHTML = '';
    }

    function showPredictive() {
      if (!predictive) return;
      predictive.hidden = false;
    }

    function createThumb(imageUrl, altText) {
      var thumb = document.createElement('div');
      thumb.className = 'search-page__predictive-thumb';
      if (imageUrl) {
        var img = document.createElement('img');
        img.src = imageUrl;
        img.alt = altText || '';
        img.loading = 'lazy';
        thumb.appendChild(img);
      }
      return thumb;
    }

    function createPredictiveLink(thumb, bodyChildren, href) {
      var link = document.createElement('a');
      link.className = 'search-page__predictive-item';
      link.href = href;
      link.appendChild(thumb);

      var body = document.createElement('div');
      body.className = 'search-page__predictive-body';
      bodyChildren.forEach(function (node) {
        body.appendChild(node);
      });
      link.appendChild(body);
      return link;
    }

    function renderPredictiveResults(query, data) {
      if (!predictive) return;
      predictive.innerHTML = '';

      var resources = data && data.resources && data.resources.results ? data.resources.results : {};
      var products = resources.products || [];
      var collections = resources.collections || [];

      products.forEach(function (product) {
        var imageUrl = product.image || (product.featured_image && product.featured_image.url) || '';
        var thumb = createThumb(imageUrl, product.title);
        var title = document.createElement('p');
        title.className = 'search-page__predictive-title';
        title.textContent = product.title;

        var price = document.createElement('p');
        price.className = 'search-page__predictive-price';
        price.textContent = product.price ? product.price : formatMoney(product.price_min || product.price);

        predictive.appendChild(
          createPredictiveLink(thumb, [title, price], product.url || searchUrl(query))
        );
      });

      collections.forEach(function (collection) {
        var thumb = createThumb(collection.image || '', collection.title);
        var meta = document.createElement('div');
        meta.className = 'search-page__predictive-meta';

        var title = document.createElement('p');
        title.className = 'search-page__predictive-title';
        title.textContent = collection.title;

        var label = document.createElement('span');
        label.className = 'search-page__predictive-category';
        label.textContent = categoryLabel;

        meta.appendChild(title);
        meta.appendChild(label);
        predictive.appendChild(createPredictiveLink(thumb, [meta], collection.url || '#'));
      });

      var showAllThumb = document.createElement('div');
      showAllThumb.className = 'search-page__predictive-thumb search-page__predictive-thumb--icon';
      showAllThumb.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="6.75" stroke="currentColor" stroke-width="1.5"/><path d="M16 16l4.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

      var showAllText = document.createElement('p');
      showAllText.className = 'search-page__predictive-show-all-text';
      showAllText.innerHTML =
        '<span class="search-page__predictive-show-all-muted">' +
        showAllPrefix +
        '</span> "' +
        query +
        '"';

      var showAllLink = createPredictiveLink(showAllThumb, [showAllText], searchUrl(query));
      predictive.appendChild(showAllLink);

      showPredictive();
    }

    function fetchPredictive(query) {
      if (activeController) activeController.abort();
      activeController = new AbortController();

      var url =
        suggestBase +
        '.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=5&resources[type]=collection&resources[limit]=2';

      fetch(url, { signal: activeController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search failed');
          return response.json();
        })
        .then(function (data) {
          renderPredictiveResults(query, data);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          hidePredictive();
        });
    }

    function toggleClearButton() {
      if (!clearBtn || !input) return;
      var hasValue = input.value.trim().length > 0;
      clearBtn.hidden = !hasValue;
      clearBtn.classList.toggle('search-bar__clear--hidden', !hasValue);
    }

    if (input) {
      input.addEventListener('input', function () {
        toggleClearButton();
        var query = input.value.trim();

        clearTimeout(debounceTimer);
        if (query.length < 2) {
          hidePredictive();
          return;
        }

        debounceTimer = setTimeout(function () {
          fetchPredictive(query);
        }, 250);
      });

      input.addEventListener('focus', function () {
        var query = input.value.trim();
        if (query.length >= 2) fetchPredictive(query);
      });
    }

    if (clearBtn && input) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        toggleClearButton();
        hidePredictive();
        input.focus();
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (window.history.length > 1) {
          window.history.back();
        } else {
          window.location.href = '/';
        }
      });
    }

    if (form && input) {
      form.addEventListener('submit', function () {
        addRecentSearch(input.value.trim());
      });
    }

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) hidePredictive();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') hidePredictive();
    });

    renderRecentSearches();
    toggleClearButton();

    if (input) {
      var urlParams = new URLSearchParams(window.location.search);
      var urlQuery = urlParams.get('q');
      if (urlQuery && !input.value.trim()) {
        input.value = urlQuery;
        toggleClearButton();
      }

      requestAnimationFrame(function () {
        input.focus({ preventScroll: true });
        var end = input.value.length;
        if (typeof input.setSelectionRange === 'function') {
          input.setSelectionRange(end, end);
        }
      });

      var initialQuery = input.value.trim();
      if (initialQuery.length >= 2 && !root.querySelector('.search-page__results')) {
        fetchPredictive(initialQuery);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
